<template>
  <div
    class="padding-10"
    :style="itemLoanStyle"
    @click="onItemClicked"
    >

    <div class="bottom-line item-row-alignment padding-bottom-10">
      <div class="item-row-alignment-center">
        <weex-image
          :src="personLogo"
          style="height: 24px;width: 24px; margin-right: 5px"
          ></weex-image>
        <weex-text class="font-weight-bold font-size-lg">{{ getClientName }}</weex-text>
      </div>
      <div class="item-row-alignment-center item-align-right">
        <weex-image
          :src="callLogo"
          style="height: 24px;width: 24px; margin-right: 5px"
          ></weex-image>
        <weex-text class="font-size-base font-weight-bold">{{ getMobileNumber }}</weex-text>
      </div>
    </div>

    <weex-text
      class="font-size-base margin-top-10"
      v-html="getDetailsWithLabel('Application ID', getAccountNumber)"
      ></weex-text>

    <weex-text
      v-if="getProductDescription"
      class="font-size-base margin-top-5"
      v-html="getDetailsWithLabel('Product Details', getProductDescription)"
      ></weex-text>

    <weex-text
      class="font-size-base margin-top-5"
      v-html="getDetailsWithLabel('Status', getLoanStatusValue)"
      ></weex-text>

    <weex-text v-if="getLenderLoanId"
      class="font-size-base margin-top-10"
      v-html="getDetailsWithLabel('Lender Loan ID', getLenderLoanId)"
      ></weex-text>

    <weex-text  v-if="getLenderLoanStatus"
      class="font-size-base margin-top-10"
      v-html="getDetailsWithLabel('Lender Loan Status', getLenderLoanStatus)"
      ></weex-text>

  </div>

</template>

<script>
  import EzUtils from "../../utils/EzUtils";
  import LoanStatusDetails, { LoanStatus } from "../../utils/LoanStatusDetails";
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import { Constants } from '../Constants';

  const MERCHANT = "MERCHANT";

  export default {
    name: "LoanItem",
    props: {
      ezLoan: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },

    methods: {
      getDetailsWithLabel(label, details) {
        return `<span style="color: blue">${label} : </span><span style="color: black">${details}</span>`;
      },

      onItemClicked() {
        if (this.getEzLoan) {
          this.$emit("onLoanSelected", this.getEzLoan);
        }
      }
    },

    computed: {
      getEzLoan() {
        let ezLoan = null;

        if (this.ezLoan) {
          if (Object.keys(this.ezLoan).includes("ezLoan")) {
            ezLoan = this.ezLoan.ezLoan;
          } else {
            ezLoan = this.ezLoan;
          }
        }
        return ezLoan;
      },

      getAssociatedEntity() {
        let associatedEntity = null;

        if (this.ezLoan) {
          if (Object.keys(this.ezLoan).includes("associatedEntity")) {
            associatedEntity = this.ezLoan.associatedEntity;
          }
        }
        return associatedEntity;
      },

      getLoan() {
        const ezLoan = this.getEzLoan;
        return ezLoan ? ezLoan.loan : null;
      },

      getLoanDetails() {
        const ezLoan = this.getEzLoan;
        return ezLoan ? ezLoan.loanDetails : null;
      },

      getLenderLoanDetails() {
        const ezLoan = this.getEzLoan
        return ezLoan ? ezLoan.lenderLoanDetail : null;
      },

      getClientName() {
        const loan = this.getLoan;
        return loan ? loan.clientName : "";
      },

      getMobileNumber() {
        const loanDetails = this.getLoanDetails;
        return loanDetails ? loanDetails.contact : "";
      },

      getAccountNumber() {
        const associatedEntity = this.getAssociatedEntity;
        const loan = this.getLoan;

        let accountNumber = "";
        if (associatedEntity && associatedEntity["associated_loan_account_number"]) {
          accountNumber = associatedEntity["associated_loan_account_number"];
        }

        if (loan && loan.accountNo) {
          accountNumber = loan.accountNo;
        }

        return accountNumber;
      },

      getProductDescription() {
        return "";
      },

      getLoanStatusValue() {
        const loanStatusDescription =
          LoanStatusDetails.getLoanStatusDescription(this.getLoanStatus);
        return this.isOnboardingLoan
          ? loanStatusDescription.onboardingStatusMessage :
          loanStatusDescription.defaultStatusMessage
      },

      getLoanStatus() {
        const associatedEntity = this.getAssociatedEntity;
        const loan = this.getLoan;

        let status = "";
        if (associatedEntity && associatedEntity["status"]) {
          status = associatedEntity["status"];
        }

        if (loan && loan.status && loan.status.value) {
          status = loan.status.value;
        }

        return status;
      },

      isOnboardingLoan() {
        return EzUtils.areEqualString(MERCHANT, this.getLeadEntity, true);
      },

      getLeadEntity() {
        const loanDetails = this.getLoanDetails;
        return loanDetails && loanDetails["lead_entity"] ? loanDetails["lead_entity"] : "";
      },

      getLenderLoanId() {
        const lenderLoanDetails = this.getLenderLoanDetails;
        return lenderLoanDetails && lenderLoanDetails[Constants.LENDER_LOAN_ID]
            ? lenderLoanDetails[Constants.LENDER_LOAN_ID]
            : null;
      },

      getLenderLoanStatus() {
        const lenderLoanDetails = this.getLenderLoanDetails;
        return lenderLoanDetails && lenderLoanDetails[Constants.LENDER_LOAN_STATUS]
            ? lenderLoanDetails[Constants.LENDER_LOAN_STATUS]
            : null;
      },

      isLoanApproved() {
        return EzUtils.areEqualString(LoanStatus.APPROVED, this.getLoanStatus, true);
      },

      isLoanActive() {
        return EzUtils.areEqualString(LoanStatus.ACTIVE, this.getLoanStatus, true);
      },

      isLoanRejected() {
        return EzUtils.areEqualString(LoanStatus.REJECTED, this.getLoanStatus, true)
            || EzUtils.areEqualString(LoanStatus.WITHDRAWN_BY_APPLICANT, this.getLoanStatus, true)
            || EzUtils.areEqualString(
                LoanStatus.WITHDRAWN_BY_APPLICANT_UNDERSCORE_UPPERCASE, this.getLoanStatus, true
            )
            || EzUtils.areEqualString(LoanStatus.WITHDRAWN_BY_CLIENT, this.getLoanStatus, true)
            || EzUtils.areEqualString(
                LoanStatus.WITHDRAWN_BY_CLIENT_UNDERSCORE_UPPERCASE, this.getLoanStatus, true
            );
      },

      itemLoanStyle() {
        let loanItemStyle = { 'border-width': '1px', 'border-style': 'solid' };
        if (this.isLoanRejected) {
          loanItemStyle['border-color'] = '#FF0000';
        } else if (this.isLoanActive || this.isLoanApproved) {
          loanItemStyle['border-color'] = '#008000';
        } else {
          loanItemStyle['border-color'] = '#0F8DE8';
        }

        if (this.getEzLoan) {
          loanItemStyle['cursor'] = 'pointer';
        } else {
          loanItemStyle['cursor'] = 'not-allowed';
          loanItemStyle['background-color'] = '#e9e7e7';
        }

        return loanItemStyle
      },

      callLogo() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CALL)
      },

      personLogo() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.PERSON);
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

